export enum CustomerStatus {
    NO_APPROVAL = 0,
    APPROVE_DISCLAIMER = 1,
    REGISTERED = 2,
};

export const convertIntToCustomerStatus = (input: number) => {
    switch(input) {
        case 0: return CustomerStatus.NO_APPROVAL;
        case 1: return CustomerStatus.APPROVE_DISCLAIMER;
        case 2: return CustomerStatus.REGISTERED;
        default: return CustomerStatus.NO_APPROVAL;
    }
}